import { toastr } from 'react-redux-toastr';
import {
  FLAG_FUEL_REPORT_PREVIEW_ACTIVITY,
  CLEAR_FUEL_REPORT_PREVIEW,
  GET_FUEL_VOUCHERS,
  GET_FUEL_REPORT_PREVIEW,
  GET_BASE_FUEL_REFILLS,
} from '../types';
import { getExtraordinaryMovementControlsAsync } from './ExtraordinaryMovementControl';
import {
  clearFuelVouchers,
  flagGettingFuelVouchers,
  getFuelVouchersAsync,
} from './FuelVoucher';
import { getExpectedFuelConsumptionsAsyncV2 } from './ExpectedFuelConsumption';
import { getItinerariesByItineraryIdListAsyncV2 } from '../itinerary';
import { DEFAULT_QUERY, DEFAULT_QUERY_GET_ALL } from '../../config/queries';
import {
  flagGettingBaseFuelRefill,
  getBaseFuelRefillByRegisteredBusIdAsync,
} from './BaseFuelRefill';
import { getExtraConsumptionByItineraryIdListAsync } from './ExtraFuelConsumption';
import { FUEL_VOUCHER_STATUS } from '../../config/constants';
import { postIdlingConsumptionsByItineraryIdListAsync } from './IdlingConsumption';

const flagFuelReportPreviewActivity = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_FUEL_REPORT_PREVIEW_ACTIVITY,
    payload: flag,
  });

const getFuelReportPreview =
  async ({ circuitGroupItineraryList, registeredBusId }) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingFuelVouchers(true));
      dispatch(flagGettingBaseFuelRefill(true));
      dispatch(flagFuelReportPreviewActivity(true));

      dispatch(clearFuelVouchers());

      // Join itineraries by "|"
      const itinerariesJoined = circuitGroupItineraryList
        .map(({ itineraryId }) => itineraryId)
        .join('|');

      // Get created fuel vouchers
      const fuelVoucherQuery = [`itineraryId:${itinerariesJoined}`];

      const createdFuelVouchers = await getFuelVouchersAsync({
        ...DEFAULT_QUERY_GET_ALL,
        query: [
          ...fuelVoucherQuery,
          `fuelVoucherStatus:${FUEL_VOUCHER_STATUS.CREATED.value}`,
        ],
      });

      // Get invoiced fuel vouchers
      const invoicedFuelVouchers = await getFuelVouchersAsync({
        ...DEFAULT_QUERY_GET_ALL,
        query: [
          ...fuelVoucherQuery,
          `fuelVoucherStatus:${FUEL_VOUCHER_STATUS.INVOICED.value}`,
        ],
      });

      // Get only ten base fuel refill for show in table
      const tenBaseRefills = await getBaseFuelRefillByRegisteredBusIdAsync(
        registeredBusId,
        DEFAULT_QUERY,
      );

      // Get all base fuel refills
      const allBaseRefills = await getBaseFuelRefillByRegisteredBusIdAsync(
        registeredBusId,
        DEFAULT_QUERY_GET_ALL,
      );

      // Constant to save itineraries
      const itineraries = [];

      // Get itineraries per itinerary id list
      const itineraryPromisesReponse =
        await getItinerariesByItineraryIdListAsyncV2({
          itineraryIdList: circuitGroupItineraryList,
        });

      // Get extra consumptions per itinerary id list
      const extraConsumptionPromisesResponse =
        await getExtraConsumptionByItineraryIdListAsync({
          itineraryIdList: circuitGroupItineraryList,
        });

      // Get idling consumptions per itinerary id list
      const idlingConsumptionsResponse =
        await postIdlingConsumptionsByItineraryIdListAsync(
          circuitGroupItineraryList.map(({ itineraryId }) => itineraryId),
        );

      // Garantiza que siempre sea un arreglo
      const idlingConsumptions = Array.isArray(idlingConsumptionsResponse)
        ? idlingConsumptionsResponse
        : [];

      console.log(
        '[Idling Consumption] Respuesta completa:',
        idlingConsumptions,
      );

      // Get expected fuel consumption
      const routesJoined = itineraryPromisesReponse
        .map(({ status, value }) => {
          if (status !== 'fulfilled' || !value) {
            return 0;
          }

          return value.routeId;
        })
        .join('|');

      const routeQuery = {
        ...DEFAULT_QUERY_GET_ALL,
        query: [`route.id:${routesJoined}`],
      };

      const expectedConsumptions = await getExpectedFuelConsumptionsAsyncV2(
        routeQuery,
      );

      // Get extraordinary movement data
      const extraordinaryMovementControls =
        await getExtraordinaryMovementControlsAsync({
          ...DEFAULT_QUERY_GET_ALL,
          query: [`itineraryId:${itinerariesJoined}`],
        });

      // Calculate kilometers for regular itineraries
      let totalKilometers = 0;

      // Calculate extra consumptions
      let totalExtraFuelConsumption = 0;

      // Calculate expected consumptions
      let totalExpectedFuelConsumption = 0;

      // Calculate fuel general in fuel vouchers
      let regularFuelInFuelVouchers = 0;

      // Calculate fuel general in idling consumption
      let totalRealIdlingConsumption = 0;

      invoicedFuelVouchers.content.forEach(
        ({ realNumberOfGallons, numberOfGallons }) => {
          regularFuelInFuelVouchers +=
            Number(realNumberOfGallons) || Number(numberOfGallons) || 0;
        },
      );

      // Calculate fuel general in base refill
      let regularFuelOnBase = 0;

      allBaseRefills.content.forEach(({ fuelQuantity, itineraryId }) => {
        const foundItinerary = circuitGroupItineraryList.some(
          (circuitGroup) =>
            Number(circuitGroup.itineraryId) === Number(itineraryId),
        );

        if (foundItinerary) {
          regularFuelOnBase += Number(fuelQuantity) || 0;
        }
      });

      // For know if there are itineraries without expected fuel consumption
      let hasNotExpectedFuelConsumptions = false;

      let hasItinerariesWithoutExtraordinaryRealValue = false;

      // Calculate fuel consumption for extraordinary itineraries
      let extraordinaryFuelConsumption = 0;

      extraordinaryMovementControls.content.forEach(
        ({ authorizedFuelConsumption }) => {
          extraordinaryFuelConsumption +=
            Number(authorizedFuelConsumption) || 0;
        },
      );

      /*
       * Suma general de todos los consumos por ralentí.
       * Si no existe el valor real, utiliza el valor programado.
       */
      idlingConsumptions.forEach((item) => {
        const consumption =
          item.realIdlingConsumptionNumberOfGallon !== null &&
          item.realIdlingConsumptionNumberOfGallon !== undefined
            ? item.realIdlingConsumptionNumberOfGallon
            : item.idlingConsumptionNumberOfGallon;

        const numericConsumption = Number(consumption);

        totalRealIdlingConsumption += Number.isNaN(numericConsumption)
          ? 0
          : numericConsumption;
      });

      console.log(
        '[Idling Consumption] Total general:',
        totalRealIdlingConsumption,
      );

      // Real fuel consumption for regular and extraordinary itineraries
      const totalFuelConsumption =
        regularFuelOnBase +
        regularFuelInFuelVouchers +
        extraordinaryFuelConsumption;

      let generalFuelInBase = 0;

      // Generate data for itineraries
      itineraryPromisesReponse.forEach((itineraryResponse) => {
        const { status: itineraryStatus, value } = itineraryResponse;

        if (itineraryStatus !== 'fulfilled' || !value) {
          return;
        }

        const {
          id,
          route,
          serviceType,
          active,
          trip,
          departureTime,
          type,
          extraordinary,
          circuit,
          routeId,
        } = value;

        let kilometers = 0;
        let expectedFuelConsumption = 0;
        let expectedAdblueConsumption = 0;
        let fuelInFuelVoucher = 0;
        let fuelOnBase = 0;
        let AdblueInBase = 0;
        let calculatedRealFuelConsumption = 0;
        let extraFuelConsumption = 0;
        let extraAdblueConsumption = 0;

        /*
         * Obtiene TODOS los consumos por ralentí
         * pertenecientes al itinerario.
         */
        const itineraryIdlingConsumptions = idlingConsumptions.filter(
          (item) => Number(item.itineraryId) === Number(id),
        );

        /*
         * Suma TODOS los consumos por ralentí
         * encontrados para el itinerario.
         */
        const realIdlingConsumptionNumberOfGallon =
          itineraryIdlingConsumptions.reduce((total, item) => {
            const consumption =
              item.realIdlingConsumptionNumberOfGallon !== null &&
              item.realIdlingConsumptionNumberOfGallon !== undefined
                ? item.realIdlingConsumptionNumberOfGallon
                : item.idlingConsumptionNumberOfGallon;

            const numericConsumption = Number(consumption);

            return (
              total +
              (Number.isNaN(numericConsumption) ? 0 : numericConsumption)
            );
          }, 0);

        console.log('[Idling Consumption] Resultado por itinerario:', {
          itineraryId: id,
          observations: itineraryIdlingConsumptions,
          numberOfObservations: itineraryIdlingConsumptions.length,
          total: realIdlingConsumptionNumberOfGallon,
        });

        // Calculate extra consumption per itinerary
        extraConsumptionPromisesResponse.forEach(
          ({
            status: extraConsumptionStatus,
            value: extraConsumptionValue,
          }) => {
            if (
              extraConsumptionStatus === 'fulfilled' &&
              extraConsumptionValue &&
              Number(extraConsumptionValue.itineraryId) === Number(id)
            ) {
              extraFuelConsumption +=
                Number(extraConsumptionValue.fuelGallons) || 0;

              extraAdblueConsumption +=
                Number(extraConsumptionValue.adblueGallons) || 0;
            }
          },
        );

        // Calculate fuel in fuel vouchers per itinerary
        createdFuelVouchers.content.forEach(
          ({ itineraryId, realNumberOfGallons, numberOfGallons }) => {
            if (Number(itineraryId) === Number(id)) {
              fuelInFuelVoucher +=
                Number(realNumberOfGallons) || Number(numberOfGallons) || 0;
            }
          },
        );

        invoicedFuelVouchers.content.forEach(
          ({ itineraryId, realNumberOfGallons, numberOfGallons }) => {
            if (Number(itineraryId) === Number(id)) {
              fuelInFuelVoucher +=
                Number(realNumberOfGallons) || Number(numberOfGallons) || 0;
            }
          },
        );

        // Calculate fuel in base refill per itinerary
        allBaseRefills.content.forEach(
          ({ itineraryId, fuelQuantity, adblueQuantity }) => {
            if (Number(itineraryId) === Number(id)) {
              fuelOnBase += Number(fuelQuantity) || 0;

              AdblueInBase += Number(adblueQuantity) || 0;

              generalFuelInBase = Number(fuelOnBase);
            }
          },
        );

        let hasNotExtraordinaryRealValue = false;

        // If itinerary is regular
        if (!extraordinary) {
          route.routeSegmentList.forEach(({ segment: { distance } }) => {
            kilometers += Number(distance) || 0;
          });

          /*
           * Agrega la suma completa del consumo
           * por ralentí al consumo esperado.
           */
          expectedFuelConsumption += realIdlingConsumptionNumberOfGallon;

          // Find expected consumptions per routeId
          const foundExpectedConsumptions = expectedConsumptions.content.find(
            (expectedConsumption) =>
              Number(expectedConsumption.routeId) === Number(routeId),
          );

          if (foundExpectedConsumptions) {
            foundExpectedConsumptions.busFuelGroupConsumptionList.forEach(
              ({ numberOfGallon, numberOfGallonAdblue, busFuelGroupId }) => {
                if (
                  Number(busFuelGroupId) ===
                  Number(trip.assignedRegisteredBus.busFuelGroupId)
                ) {
                  expectedFuelConsumption += Number(numberOfGallon) || 0;

                  expectedAdblueConsumption +=
                    Number(numberOfGallonAdblue) || 0;
                }
              },
            );
          }

          // Set base fuel refill for all itineraries
          fuelOnBase = generalFuelInBase;
        } else {
          const foundExtraordinaryMovementControls =
            extraordinaryMovementControls.content.find(
              ({ itineraryId }) => Number(itineraryId) === Number(id),
            );

          if (foundExtraordinaryMovementControls) {
            kilometers =
              foundExtraordinaryMovementControls.realKilometers ||
              foundExtraordinaryMovementControls.initialKilometers;

            calculatedRealFuelConsumption =
              foundExtraordinaryMovementControls.authorizedFuelConsumption;

            AdblueInBase =
              foundExtraordinaryMovementControls.realAdblueConsumption;

            ({ expectedFuelConsumption, expectedAdblueConsumption } =
              foundExtraordinaryMovementControls);

            if (
              (!foundExtraordinaryMovementControls.initialSourceLocationName &&
                !foundExtraordinaryMovementControls.realSourceLocationName) ||
              (!foundExtraordinaryMovementControls.initialDestinationLocationName &&
                !foundExtraordinaryMovementControls.realDestinationLocationName) ||
              (!foundExtraordinaryMovementControls.initialKilometers &&
                !foundExtraordinaryMovementControls.realKilometers) ||
              (foundExtraordinaryMovementControls.initialKilometers === 0 &&
                foundExtraordinaryMovementControls.realKilometers === 0)
            ) {
              hasNotExtraordinaryRealValue = true;

              hasItinerariesWithoutExtraordinaryRealValue = true;
            }
          }
        }

        totalKilometers += Number(kilometers) || 0;

        totalExtraFuelConsumption += Number(extraFuelConsumption) || 0;

        totalExpectedFuelConsumption += Number(expectedFuelConsumption) || 0;

        if (expectedFuelConsumption === 0) {
          hasNotExpectedFuelConsumptions = true;
        }

        // Set itinerary data
        itineraries.push({
          id,
          route,
          serviceType,
          active,
          trip,
          departureTime,
          type,
          extraordinary,
          circuit,
          routeId,
          kilometers,
          expectedFuelConsumption,
          expectedAdblueConsumption,
          fuelInFuelVoucher,
          calculatedRealFuelConsumption,
          AdblueInBase,
          fuelOnBase,
          extraAdblueConsumption,
          extraFuelConsumption,
          hasNotExtraordinaryRealValue,

          realIdlingFuelConsumption: realIdlingConsumptionNumberOfGallon,

          idlingConsumptionObservations: itineraryIdlingConsumptions,
        });
      });

      const factorOfTotalFuelConsumption =
        totalKilometers > 0 ? totalFuelConsumption / totalKilometers : 0;

      // Calculate real fuel consumption per itinerary
      itineraries.forEach(({ kilometers }, index) => {
        itineraries[index].calculatedRealFuelConsumption =
          Number(factorOfTotalFuelConsumption * kilometers) || 0;
      });

      const totalOfCalculatedFuelConsumption =
        Number(factorOfTotalFuelConsumption * totalKilometers) || 0;

      // Add extra fuel consumption
      totalExpectedFuelConsumption += totalExtraFuelConsumption;

      const header = {
        totalKilometers,
        totalExpectedFuelConsumption,
        totalOfCalculatedFuelConsumption,
        hasNotExpectedFuelConsumptions,
        hasItinerariesWithoutExtraordinaryRealValue,
        totalRealIdlingConsumption,
      };

      const fuelReportPreview = {
        header,
        itineraries,
      };

      console.log('[Fuel Report Preview] Resultado:', fuelReportPreview);

      // Dispatch fuel vouchers
      const fuelVouchers = {
        ...createdFuelVouchers,
      };

      fuelVouchers.content = [
        ...createdFuelVouchers.content,
        ...invoicedFuelVouchers.content,
      ];

      dispatch({
        type: GET_FUEL_VOUCHERS,
        payload: fuelVouchers,
      });

      // Dispatch base fuel refill
      dispatch({
        type: GET_BASE_FUEL_REFILLS,
        payload: tenBaseRefills,
      });

      // Dispatch fuel report preview data
      dispatch({
        type: GET_FUEL_REPORT_PREVIEW,
        payload: fuelReportPreview,
      });
    } catch ({ message }) {
      toastr.error(
        'Error',
        `Hubo en error al obtener los datos. Reporte el siguiente error a TI: ${message}`,
      );
    } finally {
      dispatch(flagGettingBaseFuelRefill(false));
      dispatch(flagGettingFuelVouchers(false));
      dispatch(flagFuelReportPreviewActivity(false));
    }
  };

const clearFuelReportPreview = () => (dispatch) =>
  dispatch({
    type: CLEAR_FUEL_REPORT_PREVIEW,
  });

export { getFuelReportPreview, clearFuelReportPreview };
